export default "__VITE_PUBLIC_ASSET__9656f77f__"